import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";
import {PermissionsConverter} from "../../../../../common/converter/permissions.converter";
import {ProviderCamMachineSummaryModel} from "./providerCamMachineSummary.model";
import {CamMachineSummaryConverter} from "../../../../../3d/cam/machine/api/model/camMachineSummary.converter";
import {LovValueSummaryConverter} from "../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class ProviderCamMachineSummaryConverter extends HttpModelConverter<ProviderCamMachineSummaryModel> {

    constructor(private permissionConverter: PermissionsConverter,
                private camMachineSummaryConverter: CamMachineSummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): ProviderCamMachineSummaryModel {
        return new ProviderCamMachineSummaryModel();
    }

    protected enrichObject(result: ProviderCamMachineSummaryModel, src: ProviderCamMachineSummaryModel) {
        result.permissions = this.permissionConverter.convert(src.permissions);
        result.camMachine = this.camMachineSummaryConverter.convert(src.camMachine);
        result.remoteInterfaceType = this.lovValueSummaryConverter.convert(src.remoteInterfaceType)
    }
}
